import { PseudoPostType } from 'constants/post';
import { Attachments } from 'types/Attachments';
import { PostComposerFormState } from '../postComposerFormState';

export const hasPseudoTypeMedia = ({
  pseudoPost,
  pseudoType,
  attachmentsByPseudoType,
}: {
  pseudoPost: PseudoPostType;
  pseudoType: PseudoPostType;
  attachmentsByPseudoType: Record<PseudoPostType, Attachments>;
}) => {
  return (
    pseudoPost === pseudoType &&
    attachmentsByPseudoType[pseudoType]?.cards?.length
  );
};

export const havePseudoTypesMedia = ({
  pseudoPost,
  pseudoTypes,
  attachmentsByPseudoType,
}: {
  pseudoPost: PseudoPostType;
  pseudoTypes: PseudoPostType[];
  attachmentsByPseudoType: Record<PseudoPostType, Attachments>;
}) => {
  return pseudoTypes.some((pseudoType) =>
    hasPseudoTypeMedia({
      pseudoPost,
      pseudoType,
      attachmentsByPseudoType,
    }),
  );
};

type GetAttachmentCards = {
  attachmentsByPseudoType: Record<PseudoPostType, Attachments>;
  pseudoType: PseudoPostType;
  form: PostComposerFormState;
};

export const getAttachmentCards = ({
  attachmentsByPseudoType,
  pseudoType,
}: GetAttachmentCards) => {
  const attachments: Attachments = attachmentsByPseudoType?.[pseudoType];
  return attachments?.cards ?? [];
};

type CanAcceptAttachmentsFromPseudoType = {
  pseudoTypes: PseudoPostType[];
  pseudoPost: PseudoPostType;
  attachmentsByPseudoType: Record<PseudoPostType, Attachments>;
};

export const canAcceptAttachmentsFromPseudoType = ({
  pseudoTypes,
  pseudoPost,
  attachmentsByPseudoType,
}: CanAcceptAttachmentsFromPseudoType) => {
  return (
    pseudoTypes.includes(pseudoPost) &&
    !havePseudoTypesMedia({
      pseudoTypes,
      pseudoPost,
      attachmentsByPseudoType,
    })
  );
};
